import React, { useEffect, useState } from 'react'

export const useEnter = (callback) => {
  function keyCheck(e){
    if(e.keyCode === 13){
      callback()
    }
  }

  useEffect(()=>{
    document.addEventListener('keypress',keyCheck)
    return ()=>document.removeEventListener('keypress',keyCheck)
  },[callback])
  return null
}